export var STRIPE_ERROR = 'stripe-error';
export var COMMERCE_CREDIT_CARD_ERROR = 'commerce-credit-card-error';